// Tremor chartUtils [v1.0.0]
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AxisDomain } from "recharts/types/util/types";

export const AvailableChartColors = [
  "color1",
  "color2",
  "color3",
  "color4",
  "color5",
  "color6",
  "color7",
  "color8",
  "color9",
  "color10",
  "color11",
  "color12",
  "color13",
  "color14",
  "color15",
  "color16",
  "color17",
  "color18",
  "color19",
  "color20",
  "color21",
  "color22",
  "color23",
  "color24",
  "color25",
  "color26",
  "color27",
  "color28",
  "color29",
  "color30",
  "color31",
  "color32",
  "color33",
  "color34",
  "color35",
  "color36",
  "color37",
  "color38",
  "color39",
  "color40",
  "color41",
  "color42",
  "color43",
  "color44",
  "color45",
  "color46",
  "color47",
  "color48",
  "color49",
  "color50",
  "turquoiseLight",
  "magenta",
  "lavender",
  "emerald",
  "red",
  "blue",
];

export type AvailableChartColorsKeys = (typeof AvailableChartColors)[number];

export const OTHERS_KEY = "Others";
/** Unique key for aggregated "Others" (e.g. Creative Share); use this for color so real "Others" keys get normal colors. */
export const AGGREGATED_OTHERS_KEY = "__CREATIVE_SHARE_AGGREGATED_OTHERS__";
export const OTHERS_BAR_COLOR = "others";

export const constructCategoryColors = (
  categories: string[],
  colors: AvailableChartColorsKeys[],
): Map<string, AvailableChartColorsKeys> => {
  const categoryColors = new Map<string, AvailableChartColorsKeys>();
  categories.forEach((category, index) => {
    if (category === AGGREGATED_OTHERS_KEY || category === OTHERS_KEY) {
      categoryColors.set(category, OTHERS_BAR_COLOR);
    } else {
      categoryColors.set(category, colors[index % colors.length]);
    }
  });
  return categoryColors;
};

export const getColorClassName = (
  color: AvailableChartColorsKeys,
  type: "bg" | "stroke" | "fill" | "text",
): string => {
  const colors: Record<AvailableChartColorsKeys, Record<string, string>> = {
    color1: {
      bg: "bg-[#3B82F699] dark:bg-[#3B82F699]",
      stroke: "stroke-[#3B82F699] dark:stroke-[#3B82F699]",
      fill: "fill-[#3B82F699] dark:fill-[#3B82F699]",
      text: "text-[#3B82F699] dark:text-[#3B82F699]",
    },
    color2: {
      bg: "bg-[#10B98199] dark:bg-[#10B98199]",
      stroke: "stroke-[#10B98199] dark:stroke-[#10B98199]",
      fill: "fill-[#10B98199] dark:fill-[#10B98199]",
      text: "text-[#10B98199] dark:text-[#10B98199]",
    },
    color3: {
      bg: "bg-[#8B5CF699] dark:bg-[#8B5CF699]",
      stroke: "stroke-[#8B5CF699] dark:stroke-[#8B5CF699]",
      fill: "fill-[#8B5CF699] dark:fill-[#8B5CF699]",
      text: "text-[#8B5CF699] dark:text-[#8B5CF699]",
    },
    color4: {
      bg: "bg-[#F59E0B99] dark:bg-[#F59E0B99]",
      stroke: "stroke-[#F59E0B99] dark:stroke-[#F59E0B99]",
      fill: "fill-[#F59E0B99] dark:fill-[#F59E0B99]",
      text: "text-[#F59E0B99] dark:text-[#F59E0B99]",
    },
    color5: {
      bg: "bg-[#6B728099] dark:bg-[#6B728099]",
      stroke: "stroke-[#6B728099] dark:stroke-[#6B728099]",
      fill: "fill-[#6B728099] dark:fill-[#6B728099]",
      text: "text-[#6B728099] dark:text-[#6B728099]",
    },
    color6: {
      bg: "bg-[#06B6D499] dark:bg-[#06B6D499]",
      stroke: "stroke-[#06B6D499] dark:stroke-[#06B6D499]",
      fill: "fill-[#06B6D499] dark:fill-[#06B6D499]",
      text: "text-[#06B6D499] dark:text-[#06B6D499]",
    },
    color7: {
      bg: "bg-[#EC489999] dark:bg-[#EC489999]",
      stroke: "stroke-[#EC489999] dark:stroke-[#EC489999]",
      fill: "fill-[#EC489999] dark:fill-[#EC489999]",
      text: "text-[#EC489999] dark:text-[#EC489999]",
    },
    color8: {
      bg: "bg-[#84CC1699] dark:bg-[#84CC1699]",
      stroke: "stroke-[#84CC1699] dark:stroke-[#84CC1699]",
      fill: "fill-[#84CC1699] dark:fill-[#84CC1699]",
      text: "text-[#84CC1699] dark:text-[#84CC1699]",
    },
    color9: {
      bg: "bg-[#D946EF99] dark:bg-[#D946EF99]",
      stroke: "stroke-[#D946EF99] dark:stroke-[#D946EF99]",
      fill: "fill-[#D946EF99] dark:fill-[#D946EF99]",
      text: "text-[#D946EF99] dark:text-[#D946EF99]",
    },
    color10: {
      bg: "bg-[#EF444499] dark:bg-[#EF444499]",
      stroke: "stroke-[#EF444499] dark:stroke-[#EF444499]",
      fill: "fill-[#EF444499] dark:fill-[#EF444499]",
      text: "text-[#EF444499] dark:text-[#EF444499]",
    },
    color11: {
      bg: "bg-[#EA580C99] dark:bg-[#EA580C99]",
      stroke: "stroke-[#EA580C99] dark:stroke-[#EA580C99]",
      fill: "fill-[#EA580C99] dark:fill-[#EA580C99]",
      text: "text-[#EA580C99] dark:text-[#EA580C99]",
    },
    color12: {
      bg: "bg-[#E11D4899] dark:bg-[#E11D4899]",
      stroke: "stroke-[#E11D4899] dark:stroke-[#E11D4899]",
      fill: "fill-[#E11D4899] dark:fill-[#E11D4899]",
      text: "text-[#E11D4899] dark:text-[#E11D4899]",
    },
    color13: {
      bg: "bg-[#C2410C99] dark:bg-[#C2410C99]",
      stroke: "stroke-[#C2410C99] dark:stroke-[#C2410C99]",
      fill: "fill-[#C2410C99] dark:fill-[#C2410C99]",
      text: "text-[#C2410C99] dark:text-[#C2410C99]",
    },
    color14: {
      bg: "bg-[#1E40AF99] dark:bg-[#1E40AF99]",
      stroke: "stroke-[#1E40AF99] dark:stroke-[#1E40AF99]",
      fill: "fill-[#1E40AF99] dark:fill-[#1E40AF99]",
      text: "text-[#1E40AF99] dark:text-[#1E40AF99]",
    },
    color15: {
      bg: "bg-[#DB277799] dark:bg-[#DB277799]",
      stroke: "stroke-[#DB277799] dark:stroke-[#DB277799]",
      fill: "fill-[#DB277799] dark:fill-[#DB277799]",
      text: "text-[#DB277799] dark:text-[#DB277799]",
    },
    color16: {
      bg: "bg-[#0EA5E999] dark:bg-[#0EA5E999]",
      stroke: "stroke-[#0EA5E999] dark:stroke-[#0EA5E999]",
      fill: "fill-[#0EA5E999] dark:fill-[#0EA5E999]",
      text: "text-[#0EA5E999] dark:text-[#0EA5E999]",
    },
    color17: {
      bg: "bg-[#A1620799] dark:bg-[#A1620799]",
      stroke: "stroke-[#A1620799] dark:stroke-[#A1620799]",
      fill: "fill-[#A1620799] dark:fill-[#A1620799]",
      text: "text-[#A1620799] dark:text-[#A1620799]",
    },
    color18: {
      bg: "bg-[#16A34A99] dark:bg-[#16A34A99]",
      stroke: "stroke-[#16A34A99] dark:stroke-[#16A34A99]",
      fill: "fill-[#16A34A99] dark:fill-[#16A34A99]",
      text: "text-[#16A34A99] dark:text-[#16A34A99]",
    },
    color19: {
      bg: "bg-[#7A1F1D99] dark:bg-[#7A1F1D99]",
      stroke: "stroke-[#7A1F1D99] dark:stroke-[#7A1F1D99]",
      fill: "fill-[#7A1F1D99] dark:fill-[#7A1F1D99]",
      text: "text-[#7A1F1D99] dark:text-[#7A1F1D99]",
    },
    color20: {
      bg: "bg-[#9D174D99] dark:bg-[#9D174D99]",
      stroke: "stroke-[#9D174D99] dark:stroke-[#9D174D99]",
      fill: "fill-[#9D174D99] dark:fill-[#9D174D99]",
      text: "text-[#9D174D99] dark:text-[#9D174D99]",
    },
    color21: {
      bg: "bg-[#C026D399] dark:bg-[#C026D399]",
      stroke: "stroke-[#C026D399] dark:stroke-[#C026D399]",
      fill: "fill-[#C026D399] dark:fill-[#C026D399]",
      text: "text-[#C026D399] dark:text-[#C026D399]",
    },
    color22: {
      bg: "bg-[#9333EA99] dark:bg-[#9333EA99]",
      stroke: "stroke-[#9333EA99] dark:stroke-[#9333EA99]",
      fill: "fill-[#9333EA99] dark:fill-[#9333EA99]",
      text: "text-[#9333EA99] dark:text-[#9333EA99]",
    },
    color23: {
      bg: "bg-[#8B5E3C99] dark:bg-[#8B5E3C99]",
      stroke: "stroke-[#8B5E3C99] dark:stroke-[#8B5E3C99]",
      fill: "fill-[#8B5E3C99] dark:fill-[#8B5E3C99]",
      text: "text-[#8B5E3C99] dark:text-[#8B5E3C99]",
    },
    color24: {
      bg: "bg-[#7C3AED99] dark:bg-[#7C3AED99]",
      stroke: "stroke-[#7C3AED99] dark:stroke-[#7C3AED99]",
      fill: "fill-[#7C3AED99] dark:fill-[#7C3AED99]",
      text: "text-[#7C3AED99] dark:text-[#7C3AED99]",
    },
    color25: {
      bg: "bg-[#6B8E0099] dark:bg-[#6B8E0099]",
      stroke: "stroke-[#6B8E0099] dark:stroke-[#6B8E0099]",
      fill: "fill-[#6B8E0099] dark:fill-[#6B8E0099]",
      text: "text-[#6B8E0099] dark:text-[#6B8E0099]",
    },
    color26: {
      bg: "bg-[#C0000099] dark:bg-[#C0000099]",
      stroke: "stroke-[#C0000099] dark:stroke-[#C0000099]",
      fill: "fill-[#C0000099] dark:fill-[#C0000099]",
      text: "text-[#C0000099] dark:text-[#C0000099]",
    },
    color27: {
      bg: "bg-[#65A30D99] dark:bg-[#65A30D99]",
      stroke: "stroke-[#65A30D99] dark:stroke-[#65A30D99]",
      fill: "fill-[#65A30D99] dark:fill-[#65A30D99]",
      text: "text-[#65A30D99] dark:text-[#65A30D99]",
    },
    color28: {
      bg: "bg-[#A56A7A99] dark:bg-[#A56A7A99]",
      stroke: "stroke-[#A56A7A99] dark:stroke-[#A56A7A99]",
      fill: "fill-[#A56A7A99] dark:fill-[#A56A7A99]",
      text: "text-[#A56A7A99] dark:text-[#A56A7A99]",
    },
    color29: {
      bg: "bg-[#A38A2A99] dark:bg-[#A38A2A99]",
      stroke: "stroke-[#A38A2A99] dark:stroke-[#A38A2A99]",
      fill: "fill-[#A38A2A99] dark:fill-[#A38A2A99]",
      text: "text-[#A38A2A99] dark:text-[#A38A2A99]",
    },
    color30: {
      bg: "bg-[#0891B299] dark:bg-[#0891B299]",
      stroke: "stroke-[#0891B299] dark:stroke-[#0891B299]",
      fill: "fill-[#0891B299] dark:fill-[#0891B299]",
      text: "text-[#0891B299] dark:text-[#0891B299]",
    },
    color31: {
      bg: "bg-[#3F621299] dark:bg-[#3F621299]",
      stroke: "stroke-[#3F621299] dark:stroke-[#3F621299]",
      fill: "fill-[#3F621299] dark:fill-[#3F621299]",
      text: "text-[#3F621299] dark:text-[#3F621299]",
    },
    color32: {
      bg: "bg-[#68C7B999] dark:bg-[#68C7B999]",
      stroke: "stroke-[#68C7B999] dark:stroke-[#68C7B999]",
      fill: "fill-[#68C7B999] dark:fill-[#68C7B999]",
      text: "text-[#68C7B999] dark:text-[#68C7B999]",
    },
    color33: {
      bg: "bg-[#FF7EB899] dark:bg-[#FF7EB899]",
      stroke: "stroke-[#FF7EB899] dark:stroke-[#FF7EB899]",
      fill: "fill-[#FF7EB899] dark:fill-[#FF7EB899]",
      text: "text-[#FF7EB899] dark:text-[#FF7EB899]",
    },
    color34: {
      bg: "bg-[#0B102099] dark:bg-[#0B102099]",
      stroke: "stroke-[#0B102099] dark:stroke-[#0B102099]",
      fill: "fill-[#0B102099] dark:fill-[#0B102099]",
      text: "text-[#0B102099] dark:text-[#0B102099]",
    },
    color35: {
      bg: "bg-[#7B73A899] dark:bg-[#7B73A899]",
      stroke: "stroke-[#7B73A899] dark:stroke-[#7B73A899]",
      fill: "fill-[#7B73A899] dark:fill-[#7B73A899]",
      text: "text-[#7B73A899] dark:text-[#7B73A899]",
    },
    color36: {
      bg: "bg-[#1F293799] dark:bg-[#1F293799]",
      stroke: "stroke-[#1F293799] dark:stroke-[#1F293799]",
      fill: "fill-[#1F293799] dark:fill-[#1F293799]",
      text: "text-[#1F293799] dark:text-[#1F293799]",
    },
    color37: {
      bg: "bg-[#877CFF99] dark:bg-[#877CFF99]",
      stroke: "stroke-[#877CFF99] dark:stroke-[#877CFF99]",
      fill: "fill-[#877CFF99] dark:fill-[#877CFF99]",
      text: "text-[#877CFF99] dark:text-[#877CFF99]",
    },
    color38: {
      bg: "bg-[#4A9A6499] dark:bg-[#4A9A6499]",
      stroke: "stroke-[#4A9A6499] dark:stroke-[#4A9A6499]",
      fill: "fill-[#4A9A6499] dark:fill-[#4A9A6499]",
      text: "text-[#4A9A6499] dark:text-[#4A9A6499]",
    },
    color39: {
      bg: "bg-[#9C874999] dark:bg-[#9C874999]",
      stroke: "stroke-[#9C874999] dark:stroke-[#9C874999]",
      fill: "fill-[#9C874999] dark:fill-[#9C874999]",
      text: "text-[#9C874999] dark:text-[#9C874999]",
    },
    color40: {
      bg: "bg-[#0F3D2E99] dark:bg-[#0F3D2E99]",
      stroke: "stroke-[#0F3D2E99] dark:stroke-[#0F3D2E99]",
      fill: "fill-[#0F3D2E99] dark:fill-[#0F3D2E99]",
      text: "text-[#0F3D2E99] dark:text-[#0F3D2E99]",
    },
    color41: {
      bg: "bg-[#3D4F1E99] dark:bg-[#3D4F1E99]",
      stroke: "stroke-[#3D4F1E99] dark:stroke-[#3D4F1E99]",
      fill: "fill-[#3D4F1E99] dark:fill-[#3D4F1E99]",
      text: "text-[#3D4F1E99] dark:text-[#3D4F1E99]",
    },
    color42: {
      bg: "bg-[#0D948899] dark:bg-[#0D948899]",
      stroke: "stroke-[#0D948899] dark:stroke-[#0D948899]",
      fill: "fill-[#0D948899] dark:fill-[#0D948899]",
      text: "text-[#0D948899] dark:text-[#0D948899]",
    },
    color43: {
      bg: "bg-[#4FA89A99] dark:bg-[#4FA89A99]",
      stroke: "stroke-[#4FA89A99] dark:stroke-[#4FA89A99]",
      fill: "fill-[#4FA89A99] dark:fill-[#4FA89A99]",
      text: "text-[#4FA89A99] dark:text-[#4FA89A99]",
    },
    color44: {
      bg: "bg-[#4A0B0B99] dark:bg-[#4A0B0B99]",
      stroke: "stroke-[#4A0B0B99] dark:stroke-[#4A0B0B99]",
      fill: "fill-[#4A0B0B99] dark:fill-[#4A0B0B99]",
      text: "text-[#4A0B0B99] dark:text-[#4A0B0B99]",
    },
    color45: {
      bg: "bg-[#6B8F6A99] dark:bg-[#6B8F6A99]",
      stroke: "stroke-[#6B8F6A99] dark:stroke-[#6B8F6A99]",
      fill: "fill-[#6B8F6A99] dark:fill-[#6B8F6A99]",
      text: "text-[#6B8F6A99] dark:text-[#6B8F6A99]",
    },
    color46: {
      bg: "bg-[#B07A5B99] dark:bg-[#B07A5B99]",
      stroke: "stroke-[#B07A5B99] dark:stroke-[#B07A5B99]",
      fill: "fill-[#B07A5B99] dark:fill-[#B07A5B99]",
      text: "text-[#B07A5B99] dark:text-[#B07A5B99]",
    },
    color47: {
      bg: "bg-[#4338CA99] dark:bg-[#4338CA99]",
      stroke: "stroke-[#4338CA99] dark:stroke-[#4338CA99]",
      fill: "fill-[#4338CA99] dark:fill-[#4338CA99]",
      text: "text-[#4338CA99] dark:text-[#4338CA99]",
    },
    color48: {
      bg: "bg-[#0B3C5D99] dark:bg-[#0B3C5D99]",
      stroke: "stroke-[#0B3C5D99] dark:stroke-[#0B3C5D99]",
      fill: "fill-[#0B3C5D99] dark:fill-[#0B3C5D99]",
      text: "text-[#0B3C5D99] dark:text-[#0B3C5D99]",
    },
    color49: {
      bg: "bg-[#1D4ED899] dark:bg-[#1D4ED899]",
      stroke: "stroke-[#1D4ED899] dark:stroke-[#1D4ED899]",
      fill: "fill-[#1D4ED899] dark:fill-[#1D4ED899]",
      text: "text-[#1D4ED899] dark:text-[#1D4ED899]",
    },
    color50: {
      bg: "bg-[#C4B4AA99] dark:bg-[#C4B4AA99]",
      stroke: "stroke-[#C4B4AA99] dark:stroke-[#C4B4AA99]",
      fill: "fill-[#C4B4AA99] dark:fill-[#C4B4AA99]",
      text: "text-[#C4B4AA99] dark:text-[#C4B4AA99]",
    },
    turquoiseLight: {
      bg: "bg-[#68C7B9] dark:bg-[#68C7B9]",
      stroke: "stroke-[#68C7B9] dark:stroke-[#68C7B9]",
      fill: "fill-[#68C7B9] dark:fill-[#68C7B9]",
      text: "text-[#68C7B9] dark:text-[#68C7B9]",
    },
    magenta: {
      bg: "bg-[#FF7EB8] dark:bg-[#FF7EB8]",
      stroke: "stroke-[#FF7EB8] dark:stroke-[#FF7EB8]",
      fill: "fill-[#FF7EB8] dark:fill-[#FF7EB8]",
      text: "text-[#FF7EB8] dark:text-[#FF7EB8]",
    },
    lavender: {
      bg: "bg-[#877CFF] dark:bg-[#877CFF]",
      stroke: "stroke-[#877CFF] dark:stroke-[#877CFF]",
      fill: "fill-[#877CFF] dark:fill-[#877CFF]",
      text: "text-[#877CFF] dark:text-[#877CFF]",
    },
    emerald: {
      bg: "bg-emerald-500/60 dark:bg-emerald-500/60",
      stroke: "stroke-emerald-500/60 dark:stroke-emerald-500/60",
      fill: "fill-emerald-500/60 dark:fill-emerald-500/60",
      text: "text-emerald-500/60 dark:text-emerald-500/60",
    },
    red: {
      bg: "bg-red/60 dark:bg-red/60",
      stroke: "stroke-red/60 dark:stroke-red/60",
      fill: "fill-red/60 dark:fill-red/60",
      text: "text-red/60 dark:text-red/60",
    },
    blue: {
      bg: "bg-blue-500/60 dark:bg-blue-500/60",
      stroke: "stroke-blue-500/60 dark:stroke-blue-500/60",
      fill: "fill-blue-500/60 dark:fill-blue-500/60",
      text: "text-blue-500/60 dark:text-blue-500/60",
    },
    others: {
      bg: "bg-[#CCD1DE99] dark:bg-[#CCD1DE99]",
      stroke: "stroke-[#CCD1DE99] dark:stroke-[#CCD1DE99]",
      fill: "fill-[#CCD1DE99] dark:fill-[#CCD1DE99]",
      text: "text-[#CCD1DE99] dark:text-[#CCD1DE99]",
    },
  };

  return colors[color][type];
};

export const getNiceYAxisDomain = (
  data: Record<string, unknown>[],
  categories: string[],
): [number, number] => {
  if (!data.length || !categories.length) return [0, 100];

  // Find min and max values across all categories
  let minValue = Infinity;
  let maxValue = -Infinity;

  data.forEach((item) => {
    categories.forEach((category) => {
      const value = Number(item[category]);
      if (!isNaN(value)) {
        minValue = Math.min(minValue, value);
        maxValue = Math.max(maxValue, value);
      }
    });
  });

  if (minValue === Infinity || maxValue === -Infinity) return [0, 100];

  // Add some padding (5% on each side instead of 10%)
  const range = maxValue - minValue;
  const padding = range * 0.05;
  minValue = Math.max(0, minValue - padding);
  maxValue = maxValue + padding;

  // Round to nice numbers, but don't go too far above the actual max
  const niceMin = Math.floor(minValue);
  const niceMax = Math.ceil(maxValue);

  return [niceMin, niceMax];
};

export const getYAxisDomain = (
  autoMinValue: boolean,
  minValue: number | undefined,
  maxValue: number | undefined,
): AxisDomain => {
  const minDomain = autoMinValue ? "dataMin" : (minValue ?? 0);
  const maxDomain = maxValue ?? "dataMax";

  return [minDomain, maxDomain];
};

/**
 * Estimate text width in pixels (approximation for common fonts)
 * More accurate: ~6px per character for 12px font
 */
const estimateTextWidth = (text: string, fontSize: number = 12): number => {
  const avgCharWidth = fontSize * 0.3; // Very tight: 30% of font size
  return text.length * avgCharWidth;
};

let measureCanvas: HTMLCanvasElement | null = null;

/**
 * Measure text width accurately using canvas context
 * Uses the same font settings as the chart labels (12px, system fonts)
 */
export const measureTextWidth = (text: string, fontSize: number = 12): number => {
  if (!measureCanvas && typeof document !== "undefined") {
    measureCanvas = document.createElement("canvas");
  }
  const context = measureCanvas?.getContext("2d") ?? null;
  if (!context) {
    // Fallback to estimation if canvas is not available
    return estimateTextWidth(text, fontSize);
  }
  // Match chart label font styling
  context.font = `${fontSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`;
  const metrics = context.measureText(text);
  return metrics.width;
};

/**
 * Calculate dynamic left margin based on first x label
 */
export const calculateLeftMargin = (
  data: Record<string, any>[],
  index: string,
  yAxisLabel?: string,
  baseValue: number = 42,
  leftMarginFraction: number = 1,
): number => {
  if (!data?.length) return baseValue;

  // Calculate how much the first rotated x-label extends to the left
  const firstXLabel = String(data[0]?.[index] || "");
  const xLabelWidth = estimateTextWidth(firstXLabel, 12);
  const horizontalExtension = xLabelWidth * Math.cos(Math.PI / 6);
  // Use maximum of base margin (42) or horizontal extension + safe margin
  const leftMargin = Math.max(baseValue, horizontalExtension * leftMarginFraction);
  return yAxisLabel ? Math.max(leftMargin, baseValue) : leftMargin;
};

/**
 * Calculate dynamic bottom margin based on max x label length
 */
export const calculateBottomMargin = (
  data: Record<string, any>[],
  index: string,
  xAxisLabel?: string,
): number => {
  if (!data?.length) return 20;
  // Find the longest x-axis label
  const longestLabel = data.reduce((max, dp) => {
    const label = String(dp[index] || "");
    return label.length > max.length ? label : max;
  }, "");
  const labelWidth = estimateTextWidth(longestLabel, 12);
  // At -30° rotation, the vertical height = labelWidth * sin(30°) ≈ labelWidth * 0.5
  const verticalHeight = labelWidth * Math.sin(Math.PI / 6);
  // Minimal base spacing (2px) + tick line (2px) + vertical height + safe margin
  const bottomMargin = 4 + verticalHeight + 10;
  return xAxisLabel ? Math.max(bottomMargin, 20) : bottomMargin;
};

/**
 * Calculate dynamic margins for charts
 * Merges provided margins with calculated ones (partial overrides)
 */
export const calculateDynamicMargins = (
  data: Record<string, any>[],
  index: string,
  providedMargins?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  },
  xAxisLabel?: string,
  yAxisLabel?: string,
  baseLeftMargin: number = 42,
  leftMarginFraction: number = 1,
) => {
  const calculatedMargins = {
    top: 5, // fixed margin for top
    right: 10, // fixed margin for right
    bottom: calculateBottomMargin(data, index, xAxisLabel),
    left: calculateLeftMargin(
      data,
      index,
      yAxisLabel,
      baseLeftMargin,
      leftMarginFraction,
    ),
  };
  return {
    top: providedMargins?.top ?? calculatedMargins.top,
    right: providedMargins?.right ?? calculatedMargins.right,
    bottom: providedMargins?.bottom ?? calculatedMargins.bottom,
    left: providedMargins?.left ?? calculatedMargins.left,
  };
};

export const hasOnlyOneValueForKey = (
  data: Record<string, unknown>[],
  key: string,
): boolean => {
  return data.every((item) => item[key] === data[0]?.[key]);
};

export const getColorHex = (color: AvailableChartColorsKeys): string => {
  const colorMap: Record<AvailableChartColorsKeys, string> = {
    color1: "#3B82F699",
    color2: "#10B98199",
    color3: "#8B5CF699",
    color4: "#F59E0B99",
    color5: "#6B728099",
    color6: "#06B6D499",
    color7: "#EC489999",
    color8: "#84CC1699",
    color9: "#D946EF99",
    color10: "#EF444499",
    color11: "#EA580C99",
    color12: "#E11D4899",
    color13: "#C2410C99",
    color14: "#1E40AF99",
    color15: "#DB277799",
    color16: "#0EA5E999",
    color17: "#A1620799",
    color18: "#16A34A99",
    color19: "#7A1F1D99",
    color20: "#9D174D99",
    color21: "#C026D399",
    color22: "#9333EA99",
    color23: "#8B5E3C99",
    color24: "#7C3AED99",
    color25: "#6B8E0099",
    color26: "#C0000099",
    color27: "#65A30D99",
    color28: "#A56A7A99",
    color29: "#A38A2A99",
    color30: "#0891B299",
    color31: "#3F621299",
    color32: "#68C7B999",
    color33: "#FF7EB899",
    color34: "#0B102099",
    color35: "#7B73A899",
    color36: "#1F293799",
    color37: "#877CFF99",
    color38: "#4A9A6499",
    color39: "#9C874999",
    color40: "#0F3D2E99",
    color41: "#3D4F1E99",
    color42: "#0D948899",
    color43: "#4FA89A99",
    color44: "#4A0B0B99",
    color45: "#6B8F6A99",
    color46: "#B07A5B99",
    color47: "#4338CA99",
    color48: "#0B3C5D99",
    color49: "#1D4ED899",
    color50: "#C4B4AA99",
    turquoiseLight: "#68C7B9",
    magenta: "#FF7EB8",
    lavender: "#877CFF",
    emerald: "#10B981",
    red: "#EF4444",
    blue: "#3B82F6",
    others: "#CCD1DE99",
  };
  return colorMap[color];
};

// Function to calculate a "nice" Y-axis domain with a fixed number of ticks (e.g., 5)
// Always starts at 0 and calculates max value based on data
export const calculateNiceYAxisDomain = (
  data: Record<string, any>[],
  categories: string[],
  autoMinValue: boolean,
  minValue?: number,
  maxValue?: number,
  tickCount: number = 5, // Default to 5 ticks
): AxisDomain => {
  if (!data.length || !categories.length) return [0, 100];

  // If maxValue is explicitly provided, use it directly
  if (maxValue !== undefined) {
    const minVal = minValue !== undefined ? minValue : 0;
    return [minVal, maxValue];
  }

  let dataMaxValue = -Infinity;

  data.forEach((item) => {
    categories.forEach((category) => {
      const value = Number(item[category]);
      if (!isNaN(value)) {
        dataMaxValue = Math.max(dataMaxValue, value);
      }
    });
  });

  if (dataMaxValue === -Infinity) return [0, 100];

  // Use provided minValue or default to 0
  const minVal = minValue !== undefined ? minValue : 0;
  const range = dataMaxValue - minVal;

  // Handle case when all values are 0 (range is 0)
  if (range === 0 || dataMaxValue === 0) {
    // Return a default domain that shows the zero line with some padding
    return [minVal, minVal + 8];
  }

  // Ensure at least 2 ticks for a range, otherwise default to 1 interval
  const actualTickCount = Math.max(2, tickCount);
  const rawInterval = range / (actualTickCount - 1);

  // Calculate a "nice" interval
  const magnitudeOrder = Math.pow(10, Math.floor(Math.log10(rawInterval)));
  let interval = magnitudeOrder;
  if (rawInterval / magnitudeOrder > 5) {
    interval = magnitudeOrder * 10;
  } else if (rawInterval / magnitudeOrder > 2) {
    interval = magnitudeOrder * 5;
  } else if (rawInterval / magnitudeOrder > 1) {
    interval = magnitudeOrder * 2;
  }

  let niceMaxTick = Math.ceil(dataMaxValue / interval) * interval;
  const niceMinTick = minVal;

  // Ensure niceMaxTick is greater than dataMaxValue if it's too close
  if (niceMaxTick <= dataMaxValue) {
    niceMaxTick += interval;
  }

  return [niceMinTick, niceMaxTick];
};

// Function to generate custom ticks based on a calculated domain and tick count
export const generateCustomTicks = (
  domain: AxisDomain,
  tickCount: number = 5,
  allowDecimals: boolean = true,
): number[] => {
  if (
    Array.isArray(domain) &&
    typeof domain[0] === "number" &&
    typeof domain[1] === "number"
  ) {
    const [min, max] = domain as [number, number];
    const ticks: number[] = [];
    if (tickCount <= 1) {
      return [min];
    }

    const interval = (max - min) / (tickCount - 1);
    for (let i = 0; i < tickCount; i++) {
      const tickValue = min + i * interval;
      // Round to integers if allowDecimals is false
      ticks.push(allowDecimals ? tickValue : Math.round(tickValue));
    }
    return ticks;
  }

  // Fallback if domain is not numeric (e.g., "dataMin", "dataMax")
  return [];
};

// Value formatter for percentages
export function valueToPercent(value: number) {
  return `${(value * 100).toFixed(0)}%`;
}
